import { RouteNames } from '@/router/RouteNames'
import { navbarGroups } from '@/router/navbarGroups'
import type { RouteRecordRaw } from 'vue-router'

const publicMeta = {
  public: true,
}

export type Route = RouteRecordRaw & {
  path: string
  name: string
  component: () => Promise<object>
  meta?: {
    navbarGroup?: string
    public?: boolean
    promoGuest?: boolean
  }
}

export const routes = <Route[]>[
  {
    path: '/',
    name: RouteNames.root,
  },
  {
    path: '/inloggen',
    name: RouteNames.login,
    component: () => import('@/views/auth/LoginView.vue'),
    meta: publicMeta,
  },
  {
    path: '/wachtwoord-vergeten',
    name: RouteNames.forgotPassword,
    component: () => import('@/views/auth/ForgotPasswordView.vue'),
    meta: publicMeta,
  },
  {
    path: '/herstel-wachtwoord',
    name: RouteNames.resetPassword,
    component: () => import('@/views/auth/ResetPasswordView.vue'),
    meta: publicMeta,
  },
  {
    path: '/account-aanvragen',
    name: RouteNames.accountRequest,
    component: () => import('@/views/auth/RequestAccount.vue'),
    meta: publicMeta,
  },
  {
    path: '/assortiment',
    name: RouteNames.products,
    component: () => import('@/views/products/ProductsView.vue'),
    meta: {
      navbarGroup: navbarGroups.assortment,
    },
  },
  {
    path: '/product/:id',
    name: RouteNames.productDetail,
    component: () => import('@/views/products/ProductDetailView.vue'),
    meta: {
      navbarGroup: navbarGroups.assortment,
    },
  },
  {
    path: '/promo-product/:id',
    name: RouteNames.promoProductDetail,
    component: () => import('@/views/products/PromoProductDetailView.vue'),
    meta: {
      navbarGroup: navbarGroups.assortment,
      promoGuest: true,
    },
  },
  {
    path: '/bestelling',
    name: RouteNames.shoppingCart,
    component: () => import('@/views/orders/ShoppingCartView.vue'),
  },
  {
    path: '/vt-bestelling',
    name: RouteNames.vtShoppingCart,
    component: () => import('@/views/orders/VtShoppingCartView.vue'),
    meta: {
      promoGuest: true,
    },
  },
  {
    path: '/vt-checkout',
    name: RouteNames.vtCheckout,
    component: () => import('@/views/orders/VtCheckoutView.vue'),
    meta: {
      promoGuest: true,
    },
  },
  {
    path: '/gebruikers',
    name: RouteNames.users,
    component: () => import('@/views/users/UsersView.vue'),
    meta: {
      navbarGroup: navbarGroups.users,
    },
  },
  {
    path: '/users/edit/:id?',
    name: RouteNames.userDetail,
    component: () => import('@/views/users/UserDetailView.vue'),
    meta: {
      navbarGroup: navbarGroups.users,
    },
  },
  {
    path: '/profiel',
    name: RouteNames.profile,
    component: () => import('@/views/users/ProfileView.vue'),
  },
  {
    path: '/ai-agents',
    name: RouteNames.mcpSettings,
    component: () => import('@/views/users/McpSettingsView.vue'),
  },
  {
    path: '/prijswijzigingen',
    name: RouteNames.productPriceUpdates,
    component: () => import('@/views/product-price-updates/ProductPriceUpdatesView.vue'),
    meta: {
      navbarGroup: navbarGroups.priceUpdates,
    },
  },
  {
    path: '/bestelling-bevestigd',
    name: RouteNames.orderConfirmed,
    component: () => import('@/views/orders/OrderConfirmedView.vue'),
  },
  {
    path: '/vt-bestelling-bevestigd',
    name: RouteNames.vtOrderConfirmed,
    component: () => import('@/views/orders/VtOrderConfirmedView.vue'),
    meta: {
      promoGuest: true,
    },
  },
  {
    path: '/bestel-overzicht',
    name: RouteNames.orderHistory,
    component: () => import('@/views/orders/OrderHistoryView.vue'),
  },
  {
    path: '/vt-bestel-overzicht',
    name: RouteNames.vtOrderHistory,
    component: () => import('@/views/orders/VtOrderHistoryView.vue'),
    meta: {
      promoGuest: true,
    },
  },
  {
    path: '/bestelling/:id',
    name: RouteNames.orderDetail,
    component: () => import('@/views/orders/OrderDetailView.vue'),
  },
  {
    path: '/vt-bestelling/:id',
    name: RouteNames.vtOrderDetail,
    component: () => import('@/views/orders/VtOrderDetailView.vue'),
    meta: {
      promoGuest: true,
    },
  },
  {
    path: '/acties',
    name: RouteNames.productActions,
    component: () => import('@/views/products/actions/ProductActionsView.vue'),
    meta: {
      navbarGroup: navbarGroups.actions,
    },
  },
  {
    path: '/bestellijst',
    name: RouteNames.favouriteCustomerOrderList,
    component: () => import('@/views/products/customer-order-lists/CustomerOrderListView.vue'),
    meta: {
      navbarGroup: navbarGroups.favouriteOrderList,
    },
  },
  {
    path: '/scanner',
    name: RouteNames.barcodeScanner,
    component: () => import('@/views/barcode-scanner/BarcodeScannerView.vue'),
  },
  {
    path: '/home',
    name: RouteNames.home,
    component: () => import('@/views/home/HomeView.vue'),
    meta: {
      navbarGroup: navbarGroups.home,
    },
  },
  {
    path: '/partner/:slug',
    name: RouteNames.partner,
    component: () => import('@/views/partner/PartnerView.vue'),
    meta: {
      navbarGroup: navbarGroups.partner,
    },
  },
  {
    path: '/promo/:slug',
    name: RouteNames.promoAssortment,
    component: () => import('@/views/promos/PromoAssortmentView.vue'),
    meta: {
      navbarGroup: navbarGroups.promo,
      promoGuest: true,
    },
  },
  {
    path: '/promos',
    name: RouteNames.promos,
    component: () => import('@/views/promos/PromosView.vue'),
  },
  {
    path: '/promos/edit/:id?',
    name: RouteNames.promoDetail,
    component: () => import('@/views/promos/PromoDetailView.vue'),
  },
]
